import { FC, useRef } from 'react';

import { FeatureFlag } from '@/shared/api/protocol-ts/model/dto_organization_pb';
import { useAppSelector, useMedia } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';

import { useAutoOpenTranscriptorRecording } from '@/features/transcriptorDeepLink';

import { PatientProfile } from './PatientProfile';
import { PatientProfile_DEPRECATED } from './PatientProfile_DEPRECATED';
import { PatientProfileV2 } from './PatientProfileV2';

// WARN: Temporary solution for using old and new patient profile pages during development
export const PatientProfilePageContainer: FC = () => {
  const organizationLoading = useAppSelector(
    organizationModel.selectors.selectLoading,
  );
  const { isMobile } = useMedia();

  useAutoOpenTranscriptorRecording();

  const { isFDA } = useAppSelector(
    organizationModel.selectors.selectFDAEnvironment,
  );
  const isProfileV2Enabled = useAppSelector(
    organizationModel.selectors.selectFeatureFlag(
      FeatureFlag.FeatureFlag_Enable_PatientProfileExperiment,
    ),
  );

  const showNewPatientPage = !isFDA;
  // The v2 page has no mobile layout: phones keep the current page.
  const showProfileV2 = showNewPatientPage && !isMobile && isProfileV2Enabled;
  // Stream reconnects may temporarily move the global organization state back
  // to pending. Once the organization has loaded, keep the patient workspace
  // mounted so local editor and agent state are not discarded.
  const hasLoadedOrganizationRef = useRef(false);

  if (organizationLoading === 'succeeded') {
    hasLoadedOrganizationRef.current = true;
  }

  if (!hasLoadedOrganizationRef.current) {
    return null;
  }

  if (showProfileV2) {
    return <PatientProfileV2 />;
  }

  return showNewPatientPage ? (
    <PatientProfile />
  ) : (
    <PatientProfile_DEPRECATED />
  );
};
